<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.667 4C4.747 4 4 4.746 4 5.667v20.666C4 27.253 4.746 28 5.667 28h20.666c.92 0 1.667-.746 1.667-1.667V5.667C28 4.747 27.254 4 26.333 4H5.667zm4 11a1 1 0 100 2h12.666a1 1 0 100-2H9.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCheckboxIndeterminatedFilled'
}
</script>
